import * as React from "react";
import {PageContent} from "../text-content/content.interface";

export const PageContentContext = React.createContext<PageContent>({} as any);

/* Workeround for gatsby bug in build that state that we need to export react component */
export default function dummy() {
    return ''
}